import React from 'react';
import { Card } from "primereact/card";
import { InputText } from 'primereact/inputtext';
import RotuloSeplag from '../../../../../components/RotuloSeplag';

import style from "./style.module.scss";


const CustomizedContent = (item) => {

  return (
    <Card>

      <div className={style.cabecalho}>
        <div className={`p-card-title ${item.auditoriaDTO.ultimaVersao && style.cardTitle}`}>
          {item.auditoriaDTO.revtypeFormatada}
          {item.auditoriaDTO.ultimaVersao && (
            <i className="pi pi-check " style={{ color: "#077F41", fontSize: "1rem", fontWeight: 600 }}>
              {" "}
              última versão
            </i>
          )}
        </div>
        <div className="p-card-subtitle">{`${item.auditoriaDTO.usuario}  -  ${item.auditoriaDTO.dataFormatada}`}</div>
      </div>

      <hr className={style.separador} />
      <div className="p-grid">
        <RotuloSeplag nome="Codg. Tipo" cols="12 6">
          <InputText value={item.codgTipoCertidao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Nome da Certidão" cols="12 6">
          <InputText value={item.nomeTipoCertidao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Sigla Tipo" cols="12 6">
          <InputText value={item.siglTipoCertidao} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Órgão Emissor" cols="12 6">
          <InputText value={item.idenOrgaoEmissor} disabled />
        </RotuloSeplag>

      </div>
    </Card>
  );
};

export default CustomizedContent;